import React from 'react'
import { resolveApiAssetUrl } from '../../lib/api'
import { normalizeCategoryLandingLayoutConfig } from '../../templates/categoryLanding/registry'
import { renderCategoryLandingLayout } from '../../templates/categoryLanding/layouts/registry'

export default function CategoryLandingLivePreview({
  title = '실시간 미리보기',
  heroTitle,
  heroSubtitle,
  heroImageFileId,
  sections = [],
  formEnabled = true,
  formTitle,
  formFields = [],
  introStats = [],
  customConfig = {},
}) {
  const normalizedConfig = normalizeCategoryLandingLayoutConfig(customConfig || {})
  const layoutKey = normalizedConfig?.templateStyle || 'default'
  const formBorderColor = normalizedConfig?.formBorderColor || '#cbd5e1'
  const formBorderWidth = normalizedConfig?.formBorderWidth || 1
  const recommendedTitle = normalizedConfig?.recommendedTitle || '추천상품'
  const recommendedProducts = Array.isArray(normalizedConfig?.recommendedProducts) ? normalizedConfig.recommendedProducts : []

  const formCard = formEnabled ? (
    <div className="w-full rounded-[28px] bg-white p-5 shadow-sm" style={{ border: `${formBorderWidth}px solid ${formBorderColor}` }}>
      <div className="mb-4 text-center text-lg font-bold text-slate-900">{formTitle || '상담 신청'}</div>
      <div className="space-y-3">
        {(formFields || []).map((field, idx) => (
          <div key={field?.name || idx}>
            <div className="mb-2 text-sm font-medium text-slate-500">{field?.label || field?.name || `필드 ${idx + 1}`}</div>
            {field?.type === 'textarea' ? (
              <textarea className="w-full rounded-xl border px-4 py-3 text-base bg-slate-50" disabled placeholder="미리보기" />
            ) : (
              <input className="w-full rounded-xl border px-4 py-3 text-base bg-slate-50" disabled placeholder="미리보기" />
            )}
          </div>
        ))}
      </div>
    </div>
  ) : null

  const recommendedProductsCard = (
    <div className="rounded-[24px] border border-slate-200 bg-white p-4">
      <div className="mb-3 text-left">
        <span className="inline-flex rounded-full px-3 py-1.5 text-sm font-bold text-white" style={{ backgroundColor: formBorderColor }}>
          {recommendedTitle}
        </span>
      </div>
      {recommendedProducts.length > 0 ? (
        <div className="flex flex-wrap gap-3">
          {recommendedProducts.map((item, idx) => (
            <div key={idx} className="rounded-full border border-slate-200 px-4 py-2.5 text-sm font-semibold text-slate-700">
              {item?.title || `추천상품 ${idx + 1}`}
            </div>
          ))}
        </div>
      ) : (
        <div className="text-sm leading-6 text-slate-500 break-keep">
          공개된 다른 카테고리 랜딩이 있으면 자동 노출됩니다.
        </div>
      )}
    </div>
  )

  return (
    <div className="space-y-4 rounded-2xl border bg-slate-50 p-5">
      <div className="text-lg font-semibold text-slate-900">{title}</div>
      <div className="overflow-hidden rounded-2xl border bg-white">
        {renderCategoryLandingLayout(layoutKey, {
          mode: 'live',
          heroTitle: heroTitle || '상단 제목',
          heroSubtitle: heroSubtitle || '상단 설명',
          heroImageFileId,
          sections,
          formEnabled,
          formTitle,
          introStats,
          customConfig: normalizedConfig,
          resolveAssetUrl: resolveApiAssetUrl,
          formCard,
          recommendedProductsCard,
        })}
      </div>
    </div>
  )
}
